import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { AddEmailBlacklist, EditEmailBlacklist } from './emails-blacklist.interface';

@Injectable({
    providedIn: 'root'
})
export class EmailsBlacklistService {
    private token!: string;
    private basePath = environment.interop.basePath;

    private listUrl =
        this.basePath +
        environment.interop.autorizatiiComerciale.nomenclatoare.emailsBlacklist.list;

    public listDTUrl =
        this.basePath +
        environment.interop.autorizatiiComerciale.nomenclatoare.emailsBlacklist.listDT;

    private findURL =
        this.basePath +
        environment.interop.autorizatiiComerciale.nomenclatoare.emailsBlacklist.find;

    private storeURL =
        this.basePath +
        environment.interop.autorizatiiComerciale.nomenclatoare.emailsBlacklist.store;

    private updateUrl =
        this.basePath +
        environment.interop.autorizatiiComerciale.nomenclatoare.emailsBlacklist.update;

    private deleteUrl =
        this.basePath +
        environment.interop.autorizatiiComerciale.nomenclatoare.emailsBlacklist.delete;

    private changeStatusUrl =
        this.basePath +
        environment.interop.autorizatiiComerciale.nomenclatoare.emailsBlacklist.status;

    private httpOptions: any;

    constructor(private http: HttpClient) { }

    getListDT() {
        return this.http.get(this.listDTUrl, this.httpOptions);
    }

    findEntry(id: number) {
        return this.http.post(this.findURL + id, this.httpOptions);
    }

    storeEntry(payload: AddEmailBlacklist) {
        return this.http.post(this.storeURL, payload, this.httpOptions);
    }

    updateEntry(payload: EditEmailBlacklist) {
        return this.http.put(this.updateUrl, payload, this.httpOptions);
    }

    deleteEntry(id: number) {
        return this.http.delete(this.deleteUrl + id, this.httpOptions);
    }

    changeStatus(id: number, type: number) {
        return this.http.put(this.changeStatusUrl + id, { type }, this.httpOptions);
    }

    setToken(token: string) {
        this.token = token;
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: `Bearer ${this.token}`,
            }),
        };
    }
}
